import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { submitAllForms } from "@/api";
import { ROUTES } from "@/router";
import type { MultiStepFormData } from "@/stores";
import { useMultiStepFormStore } from "@/stores";
import { PATIENT_STATUS } from "@/utils";

export const useSubmitAllForms = () => {
  const { goToNextFormStep, setPatientIdToTransfer } = useMultiStepFormStore();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (formsData: MultiStepFormData) => submitAllForms(formsData),
    onSuccess: (response) => {
      if (response.status === PATIENT_STATUS.TRANSFERRED) {
        setPatientIdToTransfer(response.transferId);
        return goToNextFormStep();
      }
      void navigate(ROUTES.endScreenRegistered);
    },
  });
};
